import { ReactNode } from "react";
import { ArtAppLoader } from "@art/shared-ui";
import AccessDenied from "../../components/access-denied";
import { usePermissionsContext } from "./permissions-provider";

export type PermissionRequirement = {
  application: string;
  feature: string;
  category: string;
};

/** Allows entry when at least one product module is available. Nested routes
 * still enforce their exact feature permission. */
export function RequireAnyPermission({
  permissions,
  loadingFallback,
  children,
}: {
  permissions: PermissionRequirement[];
  loadingFallback?: ReactNode;
  children: ReactNode;
}) {
  const { loading, has } = usePermissionsContext();

  if (loading) return <>{loadingFallback ?? <ArtAppLoader />}</>;

  const allowed = permissions.some(({ application, feature, category }) =>
    has(application, feature, category),
  );
  return allowed ? <>{children}</> : <AccessDenied />;
}
